import { UNIT_TYPES, getState, delay } from './store';

export default {
    async getOverview() {
        await delay();
        const snapshot = getState();
        const users = snapshot.users;
        const activeUsers = users.filter((u) => u.status === 'active');
        const enrolments = users.flatMap((u) => u.enrolments || []);
        const completed = enrolments.filter((e) => e.status === 'completed');
        const inProgress = enrolments.filter((e) => e.status === 'in_progress');

        const sectors = snapshot.units.filter((u) => u.type === UNIT_TYPES.SECTOR);
        const roles = snapshot.units.filter((u) => u.type === UNIT_TYPES.ROLE);

        const completionRate = enrolments.length
            ? Math.round((completed.length / enrolments.length) * 100)
            : 0;

        const ranking = [...users]
            .sort((a, b) => (b.gamificationPoints || 0) - (a.gamificationPoints || 0))
            .slice(0, 8)
            .map((u, index) => ({
                position: index + 1,
                userId: u.id,
                name: u.name,
                sectorName: snapshot.units.find((unit) => unit.id === u.sectorId)?.name || '—',
                roleName: snapshot.units.find((unit) => unit.id === u.roleId)?.name || '—',
                points: u.gamificationPoints || 0,
                level: u.gamificationLevel || 'Iniciante',
            }));

        const sectorStats = sectors.map((sector) => {
            const sectorUsers = users.filter((u) => u.sectorId === sector.id);
            const sectorEnrolments = sectorUsers.flatMap((u) => u.enrolments || []);
            const sectorCompleted = sectorEnrolments.filter((e) => e.status === 'completed').length;
            const rate = sectorEnrolments.length
                ? Math.round((sectorCompleted / sectorEnrolments.length) * 100)
                : 0;
            return { id: sector.id, name: sector.name, completionRate: rate, usersCount: sectorUsers.length };
        });

        const bestSectors = [...sectorStats]
            .filter((s) => s.completionRate > 0)
            .sort((a, b) => b.completionRate - a.completionRate)
            .slice(0, 3);
        const bestIds = new Set(bestSectors.map((s) => s.id));
        const worstSectors = [...sectorStats]
            .filter((s) => !bestIds.has(s.id))
            .sort((a, b) => a.completionRate - b.completionRate)
            .slice(0, 3);

        const userNameById = Object.fromEntries(users.map((u) => [u.id, u.name]));
        const recentActivity = snapshot.orgHistory.slice(-8).reverse().map((h) => ({
            id: h.id,
            description: `Alteração organizacional de ${userNameById[h.userId] || h.userId}`,
            createdAt: h.createdAt,
            type: 'organization',
        }));

        if (!recentActivity.length) {
            ranking.slice(0, 3).forEach((row, index) => {
                recentActivity.push({
                    id: `seed_act_${index}`,
                    description: `${row.name} alcançou o nível ${row.level}`,
                    createdAt: new Date(Date.now() - index * 86400000).toISOString(),
                    type: 'gamification',
                });
            });
        }

        return {
            totals: {
                collaborators: users.length,
                activeCollaborators: activeUsers.length,
                sectors: sectors.length,
                roles: roles.length,
                corporateCourses: snapshot.courses.length,
                enrolmentsInProgress: inProgress.length,
                enrolmentsCompleted: completed.length,
                completionRate,
                totalEnrolments: enrolments.length,
            },
            ranking,
            bestSectors,
            worstSectors,
            sectorStats,
            recentActivity,
        };
    },
};
